export default {
  playable: {
    title: 'Playable',
    download: 'Playable Download/Push',
    notes: '(No limit on Mintegral)',
    describe: '(Available / Total)',
    notesTip: 'Export items per ad channel, Mintegral exports have no limits.',
  },
  video: {
    title: 'Video',
    export: 'Video Export',
    clip: 'Intelligent Splitting',
    subtitle: 'Intelligently Recognize Subtitles',
    speech: 'Intelligently Dub',
    clone: 'Number of Cloned Voice',
  },
  expireDate: 'Expire Date:',
  expireAfter: '0 Day Left | {days} Day Left | {days} Days Left',
  expired: 'Your subscription has expired.',
  current: {
    remaining: 'Within the Package',
  },
  additional: {
    quota: 'Additional Purchase',
  },
  unlimited: 'Unlimited',
  plan: {
    tips: '(Available/Purchased)',
  },
  online: {
    storage: 'Online Storage Space',
    describe: '(Used / Total)',
    exceedPrompt:
      'If the space is full, you will not be able to create or edit projects. Please expand or clean up in time.',
  },
  subscriber: 'Subscribed',
  trial: 'Trial',
  individual: 'Individual',
  enterprise: 'Enterprise',
  refresh: {
    time: 'Package Refresh Time',
  },
  details: {
    title: 'Remaining Details',
  },
  unit: {
    coin: 'Point',
    time: 'Times',
    item: 'Items',
  },
  usage: {
    videoCredit: {
      unit: {
        description:
          'Points consumption for different AI services:<br />·Video AI Removal：45 points/second based on video duration<br />·Speech to Text: 5 points/minute based on video or audio duration<br />·Scene Detector：20 points/minute based on video duration<br />·AI Voice Cloning： 240 points per cloned voice<br />·Video Export：15 points/minute based on video duration<br />·URL to Image: Calculated based on the number of images generated, 15 points per image.',
      },
    },
  },
  subscribe: {
    now: 'Renew Now',
    tips: 'Please contact sales for renewal.',
    overtime: 'Your subscription has expired,please contact sales for renewal.',
    overtime2: 'Your subscription has expired, please renew.',
    free: {
      tips: 'You have not subscribed to this service,apply for a free trial now!',
    },
    title: 'Renew',
    otherTitle: 'Insufficient Balance',
    accountBalance: 'Account Balance',
    desc: 'Please contact sales for renewal. Or send an email to <a href="mailto:sales@mindworks-creative.com">sales@mindworks-creative.com</a> with your Playturbo username in the notes.',
    otherDesc:
      'Please contact sales for purchase. Or send an email to <a href="mailto:sales@mindworks-creative.com">sales@mindworks-creative.com</a> with your Playturbo username in the notes.',
    ok: 'OK',
  },
}
